import React from 'react';
import { useHistory } from 'react-router-dom';

const BottomNavigation = ({
	backPath,
	backButtonOnClick,
	nextButtonOnClick,
	nextButtonType,
	nextButtonDisabled,
}) => {
	const history = useHistory();

	const onBackButtonClick = () => {
		history.push(backPath);
		backButtonOnClick();
	};

	return (
		<div className="relative flex flex-wrap justify-center md:justify-between items-center h-[120px] gap-2">
			<button
				type="button"
				className="flex-shrink-0 absolute md:static left-2.5 top-1/2 -translate-y-1/2 md:translate-y-0 text-xl font-bold text-sfi-orange border-0 bg-white cursor-pointer"
				onClick={onBackButtonClick}
			>
				&lt;Back
			</button>
			<button
				type={nextButtonType}
				className="flex-shrink-0 absolute md:static w-40 md:max-w-[150px] h-12 md:h-[50px] text-2xl md:text-xl bg-sfi-light-blue text-white rounded-lg border-none cursor-pointer disabled:bg-gray-300 disabled:text-gray-500 disabled:opacity-60 disabled:cursor-not-allowed"
				onClick={nextButtonOnClick}
				disabled={nextButtonDisabled}
			>
				Continue
			</button>
		</div>
	);
};

export default BottomNavigation;
